var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contacts-page row"},[_c('div',{staticClass:"left-wrap"},[_c('kanban-header',{attrs:{"header-title":"Funil"}}),_vm._v(" "),_c('h2',[_vm._v("Souza Funnel")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }